import { render, staticRenderFns } from "./FlagshipProfilingStepEconomicDependents.vue?vue&type=template&id=85309d06&scoped=true&"
import script from "./FlagshipProfilingStepEconomicDependents.vue?vue&type=script&lang=ts&"
export * from "./FlagshipProfilingStepEconomicDependents.vue?vue&type=script&lang=ts&"
import style0 from "./FlagshipProfilingStepEconomicDependents.vue?vue&type=style&index=0&id=85309d06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85309d06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow})
